// extracted by css-extract-rspack-plugin
export default {"container":"_300gQKGfG7RurFG1Zpqfqy"};